import { KeyValue } from '@/main/models/common';
import {
  BodyshopBranchTypes,
  BodyshopBranchActionTypes
} from './bodyshopBranchTypes';
import { BodyShopFilterRequest } from '@/main/models/request/bodyshopRequest';

export function getBodyshopBranches(
  request: BodyShopFilterRequest
): BodyshopBranchActionTypes {
  return {
    type: BodyshopBranchTypes.GET_BODYSHOP_BRANCHES,
    payload: { request }
  };
}

export function saveBodyshopBranches(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): BodyshopBranchActionTypes {
  return {
    type: BodyshopBranchTypes.SAVE_BODYSHOP_BRANCHES,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerBodyshopBranches(): BodyshopBranchActionTypes {
  return {
    type: BodyshopBranchTypes.RESET_REDUCER_BODYSHOP_BRANCHES
  };
}
